export const setPermission = permission => ({
    type: 'SET_PERMISSION',
    permission
});